//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageCopyright from '../Partials/ImageCopyright.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'StageContent',
    components: { ImageCopyright },
    props: ['data', 'pressnews'],
    data() {
        return {
            isMobile: false,
            anchorItems: []
        };
    },
    mounted() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);

        // Find anchor elements immediately and again after a delay to ensure we catch everything
        this.findAnchorElements();
        setTimeout(() => {
            this.findAnchorElements();

            // Check if there's a hash in the URL and scroll to the corresponding element
            this.handleInitialHash();
        }, 500);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.innerWidth < 768;
        },
        findAnchorElements() {
            // Check if .anchor-nav is present on the page
            const anchorNav = document.querySelector('.anchor-nav');

            // If .anchor-nav exists, don't show anchor buttons
            if (anchorNav) {
                this.anchorItems = [];
                return;
            }

            const anchors = document.querySelectorAll('[data-anchor-title]');
            let items = [];

            if (anchors.length > 0) {
                anchors.forEach((anchor) => {
                    const titleText = anchor.getAttribute('data-anchor-title');
                    const hash = titleText.replace(/\W+/g, '-');

                    items.push({
                        text: titleText,
                        hash: hash,
                        click: () => {
                            this.scrollToElement(titleText);
                        }
                    });
                });
            }

            // Maximale Anzahl auf 2 beschränken
            this.anchorItems = items.slice(0, 2);
        },
        handleInitialHash() {
            // Check if there's a hash in the URL
            if (window.location.hash) {
                const hash = window.location.hash.substring(1); // Remove the # character

                // Find the anchor element with matching hash
                const anchors = document.querySelectorAll('[data-anchor-title]');
                for (let i = 0; i < anchors.length; i++) {
                    const anchor = anchors[i];
                    const titleText = anchor.getAttribute('data-anchor-title');
                    const anchorHash = titleText.replace(/\W+/g, '-');

                    // If we find a matching hash, scroll to the element
                    if (anchorHash === hash) {
                        // Slight delay to ensure the page is fully loaded
                        setTimeout(() => {
                            this.scrollToElement(titleText);
                        }, 100);
                        break;
                    }
                }
            }
        },
        scrollToElement(titleText) {
            // Find the target element directly by its data attribute value
            const target = document.querySelector(`[data-anchor-title="${titleText}"]`);

            if (target) {
                // Calculate navigation height
                let navHeight = 0;
                const navMain = document.querySelector('.navigationmain');
                const navMobile = document.querySelector('.navigationmobile');

                if (navMain && window.innerWidth >= 1101) {
                    navHeight = navMain.getBoundingClientRect().height + 40;
                } else if (navMobile) {
                    navHeight = navMobile.getBoundingClientRect().height;
                }

                // Get the target's position
                const targetPosition = this.getOffsetTop(target) - navHeight;

                // Perform the scroll without changing the URL hash
                window.scrollTo({
                    top: targetPosition,
                    left: 0,
                    behavior: 'smooth'
                });

                // Update the URL hash after the scroll starts, using replace state to avoid history entries
                const hash = titleText.replace(/\W+/g, '-');
                setTimeout(() => {
                    if (history && history.replaceState) {
                        history.replaceState(null, null, '#' + hash);
                    } else {
                        // Fallback, but this might cause a jump
                        window.location.hash = hash;
                    }
                }, 50);
            }
        },
        getOffsetTop(elem) {
            let offsetTop = 0;
            do {
                if (!isNaN(elem.offsetTop)) {
                    offsetTop += elem.offsetTop;
                }
            } while (elem = elem.offsetParent);
            return offsetTop;
        }
    },
    computed: {
        ...mapGetters(['getStoredPage']),
        safeTitle() {
            return this.headline || this.getStoredPage?.title;
        },
        image() {
            return this.$mapImageData(this.data?.image?.image);
        },
        imageMobile() {
            return this.$mapImageData(this.data?.imageMobile?.image);
        },
        text() {
            return this.data?.text;
        },
        headline() {
            if (this.data?.style !== 'inspiration') {
                return this.data?.headline || this.getStoredPage.title;
            }

            return this.data?.headline;
        },
        roofline() {
            if (this.data?.style !== 'inspiration') {
                return null;
            }

            return this.data?.roofline || this.getStoredPage.title;
        },
    },
};
